export const websocketPort = "https://unified.cascais.dev-dttsynergy.com:443";